import { ChangeEvent, useCallback, useEffect, useState } from 'react'
import { CepMask } from '../../utils/CepMask'

import * as S from './styled'

export type InputCepProps = {
  error?: boolean
  fullWidth?: boolean
  helperText?: string
  id?: string
  label?: string
  name?: string
  value?: string
  width?: number
  disabled?: boolean
  onInput?: (_value: string) => void
}

export function InputCep({
  error = false,
  fullWidth = false,
  helperText = '',
  disabled = false,
  label,
  value = '',
  width = 200,
  onInput
}: InputCepProps) {
  const [valueMask, setValueMask] = useState('')

  const onMask = useCallback(
    (val: string) => {
      const mask = CepMask(val)

      setValueMask(mask)
      !!onInput && onInput(mask)
    },
    [onInput]
  )

  useEffect(() => {
    if (value !== valueMask) onMask(value)
  })

  function onChange(e: ChangeEvent<HTMLInputElement>) {
    const newValue = e.currentTarget.value
    if (value !== newValue) onMask(newValue)
  }

  return (
    <S.InputCep
      error={error}
      helperText={helperText}
      disabled={disabled}
      label={label}
      fullWidth={fullWidth}
      onChange={onChange}
      style={{ width: !fullWidth ? width : '100%' }}
      value={valueMask}
    />
  )
}
